import { Series } from './series';
import { DicomPatient, DicomPatientStudy } from './dicomPatient';

export class PatientDataSet {
    public readonly patientModule: DicomPatient;

    public series: Array<Series> = [];

    public study?: DicomPatientStudy = {} as DicomPatientStudy;

    constructor(patient: DicomPatient) {
        this.patientModule = patient;
    }

    get PatientName(): string {
        return this.patientModule.patientName;
    }

    get PatientID(): string {
        return this.patientModule.patientId;
    }
}
